import { RightDrawerSection } from './RightDrawerSection';
import { ResizableSection } from 'common/ResizableSection';
import type { ResizableSectionProps } from 'common/ResizableSection';
import { useCompactUI } from 'hooks/useCompactUI';
import { css } from 'styled-components';

export const RightDrawerResizableSection = ({
  children,
  className,
  currentMaxHeight,
  minSectionHeight,
  useResizableProps,
  expanded,
  heading,
  topOrBottom = 'bottom',
  ...rest
}: ResizableSectionProps): React.ReactElement => {
  const { showCompactHeight } = useCompactUI();

  return (
    <ResizableSection
      className={className}
      currentMaxHeight={currentMaxHeight}
      minSectionHeight={minSectionHeight}
      useResizableProps={useResizableProps}
      expanded={expanded}
      heading={heading}
      topOrBottom="bottom"
      resizableStyles={css`
        padding: ${showCompactHeight ? '8px' : '8px 24px'};
      `}
      {...rest}
    >
      <RightDrawerSection className={className}>{children}</RightDrawerSection>
    </ResizableSection>
  );
};
